import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function WebSectionButtons() {
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [buttonWidth, setButtonWidth] = useState(0);
    const [buttonPaddingX, setButtonPaddingX] = useState(0);
    const [buttonPaddingY, setButtonPaddingY] = useState(0);

    const pageType = useSelector((state) => state.storefront.pageType);
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*12);
        setLineHeight((zoomSize/100)*18);

        setButtonWidth((zoomSize/100)*114);
        setButtonPaddingX((zoomSize/100)*10);
        setButtonPaddingY((zoomSize/100)*5);
    }, [zoomSize]);

    return (
        <div style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className="flex font-semibold">
            <div style={{ width: `${buttonWidth}px`, paddingLeft: `${buttonPaddingX}px`, paddingRight: `${buttonPaddingX}px`, paddingTop: `${buttonPaddingY}px`, paddingBottom: `${buttonPaddingY}px` }} className={`text-center outline-none border-b-2 text-nowrap ${pageType === 'STORE' ? 'border-primaryColor text-[#000000]' : 'border-transparent text-[#666666]'}`}>Store and Deals</div>

            <div style={{ width: `${buttonWidth}px`, paddingLeft: `${buttonPaddingX}px`, paddingRight: `${buttonPaddingX}px`, paddingTop: `${buttonPaddingY}px`, paddingBottom: `${buttonPaddingY}px` }} className={`text-center outline-none border-b-2 text-nowrap ${pageType === 'ABOUT' ? 'border-primaryColor text-[#000000]' : 'border-transparent text-[#666666]'}`}>About us</div>
        </div>
    );
}

export default WebSectionButtons;
